import { useCallback } from 'react'
import { httpsCallable } from 'firebase/functions'
import { functionsInstance } from '../../libraries/firebaseFunctions'

/**
 * SWR fetcher that calls Firebase cloud functions
 * The args should be an array with two values
 * [functionName, dataArguments]
 */
function useFunctionsSWRFetcher<ResponseType>() {
  return useCallback((...args) => {
    const [functionName, dataArgument] = args

    return httpsCallable<unknown, ResponseType>(functionsInstance, functionName)(dataArgument).then(res => res.data)
  }, [])
}

export default useFunctionsSWRFetcher
